module.exports = __webpack_public_path__ + "static/media/D1.f98139c0.jpg";